import { useParams, Link } from 'react-router-dom';
import { mangas, categories } from '@/mocks/mangas';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MangaCard from '@/components/feature/MangaCard';
import SEOMeta from '@/components/feature/SEOMeta';

const siteUrl = 'https://fanqiemanhua.com';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug) ?? categories[0];
  const filteredMangas = mangas.filter((m) => {
    const catMap: Record<string, string> = {
      riman: '日漫',
      hanman: '韩漫',
      guoman: '国漫',
    };
    return m.category === catMap[slug ?? 'riman'];
  });

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 番茄漫画`,
    description: `番茄漫画${category.name}分类 — ${category.description}`,
    url: `${siteUrl}/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '番茄漫画',
      url: siteUrl,
    },
  };

  return (
    <>
      <SEOMeta
        title={`${category.name} - 番茄漫画 | 免费${category.name}全集在线下拉式阅读`}
        description={`番茄漫画${category.name}连载更新，提供最新话追漫提醒，免费全集完结${category.name}，流畅下拉式滚动在线阅读体验。${category.description}`}
        keywords={`${category.name},免费${category.name},${category.name}连载,完结${category.name},番茄漫画,下拉式阅读,追更漫画`}
        canonicalUrl={`${siteUrl}/category/${slug}`}
        ogType="website"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
          <div className="py-8">
            <div className="flex items-center gap-4 mb-2">
              <div className="w-10 h-10 rounded-xl bg-primary-500/10 flex items-center justify-center">
                <i className={`${category.icon} text-xl text-primary-500`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-600 ml-14">{category.description}</p>
          </div>

          <div className="flex items-center gap-2 mb-6 pb-4 border-b border-background-200/70">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  c.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                }`}
              >
                {c.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 pb-14" data-product-shop="">
            {filteredMangas.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}